import { ElementTypeEnum } from "../common/enum/elementType";
import { ValidateMessages, ValidateMessage, ValidationResultItemValue } from "../component/validation/IValidation";
import { Validation, ValidationError } from './validate';

export const validationReducer = (messages: ValidateMessages, msg: ValidateMessage): ValidateMessages => {
  // console.log(msg);
  const validations = msg.validations || [];
  const validationCallbacks = Validation
    .filter(v => validations.includes(v.type))
    .map(v => v.callback);
  const callbackResults = validationCallbacks
    .map(fn => fn(msg.value, msg.name, msg.label))
    .filter(v => v);
  const childrenErrorMessages = msg.type === ElementTypeEnum.GROUP ?
    Object.keys(msg.value).reduce<ValidationError[]>((p, key: string) => 
    [ ...p, ...(msg.value[key].error || []) ]
  , []) : [];
  const errorMessages: ValidationError[] = Array.from(
    new Set([
      ...callbackResults.map<ValidationError>(r => {
        return { code: r.code, text: r.message };
      }),
      ...childrenErrorMessages
    ])
  ).filter(v => v);

  const validationObject: ValidationResultItemValue = {
    label: msg.label,
    value: msg.value,
    error: errorMessages,
    setErrorCallback: msg.error,
  };
  const validationReducerResult: ValidateMessages = {
    ...messages,
    [msg.name]: validationObject
  };
  
  return validationReducerResult;
};

export const callbackValidationReducer = (cb: (msgs: ValidateMessages) => void) => {
  return (messages: ValidateMessages, msg: ValidateMessage): ValidateMessages => {
    const result = validationReducer(messages, msg);
    cb(result);
    return result;
  }
}